// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:52:56.365Z
// Property: Overbrook (ID: 6737460151192629)
// Collections: 31 amenities, 37 floorplans (live), 26 photos, 79 POIs, 5 reviews, 20 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192629",
  "property_external_id": "4707264",
  "property_zillow_url": "https://www.zillow.com/b/overbrook-n-little-rock-ar-FKzP/",
  "property_apartments_url": "https://www.apartments.com/overbrook-north-little-rock-ar/457cfvl",
  "property_google_business_url": "https://www.google.com/maps/place/Overbrook/data=!4m2!3m1!1s0x0:0x40f3d1e607d77e54?sa=X&ved=2ahUKEwiC44TAxrySAxV5mWoFHcFfHkIQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321210659",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "overbrook",
  "property_name": "Overbrook",
  "property_website_url": "https://www.overbrookapthome.com/",
  "property_domain": "https://www.overbrookapthome.com/",
  "property_address": "5901 John F Kennedy Blvd",
  "property_full_address": "5901 John F Kennedy Blvd, North Little Rock, AR 72116",
  "property_address_1": "5901 J.F.K. Boulevard",
  "property_address_2": null,
  "property_address_city": "North Little Rock",
  "property_address_state": "AR",
  "property_address_zip_full": "72116-5639",
  "property_address_zip": "72116",
  "property_address_country": "US",
  "property_address_county": "Pulaski County",
  "property_neighborhood_address": "North Little Rock",
  "property_address_latitude": "34.8092742",
  "property_address_longitude": "-92.2501164",
  "property_email": "overbrook@rreafresidential.com",
  "property_phone": "(501) 758-3053",
  "property_call_tracking_phone": "501-509-9498",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Overbrook in North Little Rock, AR! Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a refreshing pool, fitness center, and clubhouse. Find your new home today—browse our availability or schedule a tour to experience our vibrant community!",
  "property_long_description": "Welcome to Overbrook, your ideal apartment community nestled in the heart of North Little Rock, AR. Choose from our thoughtfully designed floor plans, including spacious One, Two, and Three-Bedroom options tailored to suit your lifestyle. Each apartment offers the perfect blend of comfort and modern amenities, ensuring you'll feel right at home.\n\nAt Overbrook, we prioritize your convenience and well-being with an exceptional array of amenities. Dive into our sparkling pool during warmer months, stay fit in our state-of-the-art fitness center, or unwind in our inviting clubhouse. Need to get some work done? Our business center and conference rooms provide the perfect space for productivity, bolstered by complimentary Wi-Fi.\n\nEnjoy peace of mind with our dedicated on-site maintenance and property management teams, along with our Renters Insurance Program. You’ll connect with neighbors through our planned social activities, enhancing your apartment living experience. Eco-conscious residents will appreciate our EV charging stations, while the sun deck and grill area invite you to relax and enjoy the outdoors.\n\nFind your new home today at Overbrook! With a welcoming community atmosphere and an abundance of amenities, we're ready to support your ideal lifestyle. Browse our availability or schedule a tour to discover the perfect apartment for you. Your future home at Overbrook awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-3e50-736f-8924-06f939dd0e70.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living area with a large stone fireplace, comfortable seating, and an open kitchen view.",
    "public_id": "019e6475-3e50-736f-8924-06f939dd0e70",
    "storage_key": "property/6737460151192629/019e6475-3e50-736f-8924-06f939dd0e70.webp",
    "width": 1500,
    "height": 1001
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "440",
  "property_year_built": "1972",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.63636363636364",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://overbrookapartments.loftliving.com/login",
  "property_apply_now_url": "https://8444223.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6bdd-70b9-9eeb-4d235259e24d.webp",
  "property_primary_logo_media": {
    "alt_text": "Overbrook Apartments logo.",
    "public_id": "019e1df2-6bdd-70b9-9eeb-4d235259e24d",
    "storage_key": "property/6737460151192629/019e1df2-6bdd-70b9-9eeb-4d235259e24d.webp",
    "width": 1250,
    "height": 398
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6b30-73e4-b4bd-71dace49f640.webp",
  "property_secondary_logo_media": {
    "alt_text": "Overbrook Apartments logo",
    "public_id": "019e1df2-6b30-73e4-b4bd-71dace49f640",
    "storage_key": "property/6737460151192629/019e1df2-6b30-73e4-b4bd-71dace49f640.webp",
    "width": 1250,
    "height": 397
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6b30-73e4-b4bd-71dace49f640.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Overbrook Apartments logo",
    "public_id": "019e1df2-6b30-73e4-b4bd-71dace49f640",
    "storage_key": "property/6737460151192629/019e1df2-6b30-73e4-b4bd-71dace49f640.webp",
    "width": 1250,
    "height": 397
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e647c-db39-755d-8be9-c71342215446.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e647c-db39-755d-8be9-c71342215446",
    "storage_key": "property/6737460151192629/019e647c-db39-755d-8be9-c71342215446.webp",
    "width": 1250,
    "height": 398
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d4e5e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "539 - 1480",
  "property_sqft_min": "539",
  "property_sqft_max": "1480",
  "property_price_range": "739 - 1525",
  "property_price_min": "739",
  "property_price_max": "1525",
  "property_available_units": 28,
  "property_facebook_url": "https://www.facebook.com/OverbrookApartments",
  "property_instagram_url": "https://www.instagram.com/overbrook_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmRTY8bm90ocRVH7XB-bR80A",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/overbrook-apartments-north-little-rock-2",
  "property_tiktok_url": "https://www.tiktok.com/@overbrook.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Overbrook",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p>A life of comfort awaits you at Overbrook Apartments. <a href=\"/neighborhood/\">Our beautiful community</a> is located in North Little Rock, Arkansas. We are minutes from a great selection of shopping, restaurants, and entertainment. It’s only a short drive to the excitement and rich history of downtown Little Rock. Finding your perfect home has never been easier at Overbrook Apartments.</p>",
  "property_home_floorplans_blurb": "<p>Surrounding the pet-friendly community of <a href=\"/floor-plans/\">Overbrook Apartments</a> lies incredible restaurants, intriguing shops, exciting entertainment venues, and engaging parks for you to discover. Located in a prime location in North Little Rock, AR, we invite all of our future and current residents to explore our neighborhood.</p>",
  "property_home_gallery_blurb": "Welcome to Overbrook in vibrant North Little Rock, AR—a community where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, each designed with modern amenities like a refreshing pool, fitness center, and sundeck. Picture yourself living here, enjoying planned social activities and serene picnic spaces!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Overbrook in North Little Rock, AR! Explore local favorites and nearby points of interest while choosing from our stylish one, two, or three-bedroom floor plans. See what's around our community and make Overbrook your new home today!",
  "property_home_reviews_blurb": "At Overbrook in North Little Rock, residents experience a sense of belonging that feels like home. With stunning renovations and an attentive staff, our community prioritizes your comfort and safety. One resident noted, \"The staff has been warm and welcoming...we feel at home here.\" Join a thriving community today!",
  "property_neighborhood_blurb": "<p>Surrounding the pet-friendly community of <a href=\"/floor-plans/\">Overbrook Apartments</a> lies incredible restaurants, intriguing shops, exciting entertainment venues, and engaging parks for you to discover. Located in a prime location in North Little Rock, AR, we invite all of our future and current residents to explore our neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Indulge in the premium amenities of our community that are suited for every lifestyle. Soak up the sun by the shimmering swimming pool or work out at our 24-hour fitness center. Enjoy time with your pet at the bark park or relax at the clubhouse. Our team is dedicated to taking care of your needs with on-call and on-site maintenance. We can’t wait to show you your new home at <a href=\"/floor-plans/\">Overbrook Apartments!</a></p>",
  "property_applynow_blurb": "Welcome to Overbrook in North Little Rock, AR, offering spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Enjoy stellar amenities like a pool, fitness center, and clubhouse, plus online services and planned social activities. Find your new home and lease online today!",
  "property_contactus_blurb": "Discover your ideal home at Overbrook in North Little Rock, AR! Choose from our spacious one, two, or three-bedroom floor plans designed for comfort and convenience. Have questions? Contact our leasing team today to learn more about your future apartment and schedule a tour! Your perfect space awaits!",
  "property_faqs_blurb": "Discover your ideal living space at Overbrook in North Little Rock, AR! Choose from our diverse floor plans, including one, two, and three-bedroom options. Have questions? Browse our FAQs page to find answers about our community and enhance your living experience today!",
  "property_floorplans_blurb": "<p>Discover a unique combination of charm and affordability in our one, two, and three bedroom apartments for rent in <a href=\"/neighborhood/\">North Little Rock</a>. Thoughtful detailing and quality features distinguish every home. Each residence includes a refrigerator, plush carpeting, and large closets. Select homes are appointed with a balcony or patio, hardwood-style floors, and washer and dryer connections.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at Overbrook in North Little Rock, AR! Choose from spacious one, two, and three-bedroom floor plans. Enjoy top-notch amenities like a pool, fitness center, and clubhouse. Use our interactive community map to explore available apartments and secure your new residence today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your perfect home at Overbrook in North Little Rock, AR! Choose from our diverse floor plans, including one, two, and three-bedroom options. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy a welcoming atmosphere together! View all our floor plans to find your ideal space!",
  "property_residentaccess_blurb": "Welcome to Overbrook in North Little Rock, AR! Explore our diverse floor plans, featuring one, two, and three-bedroom options tailored to your lifestyle. For residents, access your portal now to easily pay rent, schedule maintenance, and stay connected. Discover the convenience of living at Overbrook today!",
  "property_reviews_blurb": "At Overbrook, community means everything. Residents rave about our “outstanding” staff who go above and beyond to create a welcoming atmosphere. With exciting updates—including a new walking trail—there's never been a better time to call North Little Rock home. Join us and experience the warmth of Overbrook living!",
  "property_created_at": "1752257254097",
  "property_scheduletour_blurb": "Discover your perfect home at Overbrook in North Little Rock, AR! Choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Ready to take the next step? Schedule a tour today and see what our residents have to say about living in our vibrant community!",
  "property_thankyou_blurb": "Thank you for your interest in Overbrook, North Little Rock's premier apartment community! We offer spacious one, two, and three-bedroom floor plans designed for your comfort. A member of our team will contact you shortly to help you find your perfect home. Explore our inviting community today!",
  "property_virtualtours_blurb": "<p>At Overbrook, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Overbrook",
  "property_seo_title_home": "Overbrook | Apartments in North Little Rock, AR",
  "property_seo_description_home": "Discover your ideal living space at Overbrook Apartments in North Little Rock, AR! Choose from spacious one, two, and three-bedroom floor plans that fit your lifestyle. Enjoy top-notch amenities including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. With online services, on-site maintenance, and planned social activities, your comfort and convenience are our top priorities. Plus, take advantage of our EV charging stations and business center for a modern living experience. Find your new home today at Overbrook!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in North Little Rock, AR",
  "property_seo_description_floorplans": "Discover your ideal living space at Overbrook in North Little Rock, AR! Explore our thoughtfully designed floor plans, featuring one, two, and three-bedroom options to suit your lifestyle. Browse our available apartment homes today and find the perfect floor plan that meets all your needs!",
  "property_seo_title_amenities": "Amenities | North Little Rock, AR Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant lifestyle at Overbrook in North Little Rock, AR! Our community offers spacious one, two, and three-bedroom floor plans with unbeatable amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Enjoy convenient online services, on-site maintenance, EV charging, and a range of planned social activities. Experience the perfect blend of comfort and convenience—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in North Little Rock, AR",
  "property_seo_description_gallery": "Discover your perfect home at Overbrook in North Little Rock, AR! Our vibrant apartment community features stunning floor plans, including one, two, and three-bedroom options designed for comfort and style. Dive into our resort-style pool, stay fit in our fully-equipped fitness center, or unwind in the stylish clubhouse. Enjoy convenient online services, engaging social activities, and on-site maintenance for a worry-free lifestyle. Explore our photo gallery and picture yourself living in luxury with top amenities, including EV charging and conference rooms. Start your journey to upscale living at Overbrook today!",
  "property_seo_title_virtualtours": "Virtual Tours | Overbrook Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Overbrook in North Little Rock, AR! Explore our diverse floor plans, featuring stylish one, two, and three bedroom apartments. Take a virtual tour of our community today and see why Overbrook is the ideal choice for your next home. Don’t miss out - experience it all online now!",
  "property_seo_title_interactivemap": "Interactive Map | Overbrook Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Overbrook in North Little Rock, AR! With our diverse floor plans—one, two, and three-bedroom apartments—there's a perfect fit for everyone. Enjoy top-notch amenities including a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Plus, benefit from on-site management, planned social activities, and convenient online services. Use our interactive community map to explore available apartments, view pricing, and secure your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Little Rock, AR",
  "property_seo_description_neighborhood": "\"Discover the vibrant neighborhood surrounding Overbrook in North Little Rock, AR! Explore local favorites, nearby points of interest, and the convenience of our one, two, and three-bedroom floor plans. See what's around our community and experience the perfect blend of comfort and convenience today!\"",
  "property_seo_title_contact": "Contact Us | Overbrook",
  "property_seo_description_contact": "Discover your ideal living space at Overbrook, North Little Rock's premier apartment community. Explore our diverse floor plans—One, Two, and Three Bedrooms—designed to fit your lifestyle. Have questions? Contact our leasing team today for more information! ",
  "property_seo_title_faqs": "FAQs | Apartments in North Little Rock, AR",
  "property_seo_description_faqs": "Discover everything you need to know about Overbrook Apartments in North Little Rock, AR! From our diverse floor plans—featuring one, two, and three-bedroom options—to exceptional amenities like a refreshing pool, modern fitness center, and welcoming clubhouse, we’ve got you covered. Have questions? Browse our FAQs page to find answers about our community features, from our convenient online services to planned social activities and EV charging. Experience the Overbrook difference today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Little Rock, AR",
  "property_seo_description_reviews": "Discover life at Overbrook in North Little Rock, AR, where comfort meets convenience! Explore our diverse floor plans, including one, two, and three-bedroom apartments, designed to suit your lifestyle. Enjoy exceptional amenities like a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Stay connected with online services and experience community spirit through planned social activities. Read our resident reviews to see why our community is the perfect place to call home. See what our residents have to say about living at our community today!",
  "property_seo_title_applynow": "Apply Now | Apartments in North Little Rock, AR",
  "property_seo_description_applynow": "Discover your new home at Overbrook in North Little Rock, AR! Choose from spacious 1, 2, and 3-bedroom floor plans, perfect for any lifestyle. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Our community also offers convenient online services, a business center, and planned social activities for a vibrant living experience. Plus, with on-site maintenance and property management, your comfort is our priority. Don’t miss out—apply now and lease your perfect apartment today!",
  "property_seo_title_residentaccess": "Resident Access | Overbrook",
  "property_seo_description_residentaccess": "\"Welcome to the Overbrook Resident Portal in North Little Rock, AR! Access your account to easily pay rent, schedule maintenance, and manage your community details. Join our vibrant community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Overbrook",
  "property_seo_description_referafriend": "\"Discover the joy of community at Overbrook in North Little Rock, AR! Great friends make great neighbors—refer a friend today and share the benefits of living in our welcoming apartment community. Enjoy exclusive rewards together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Overbrook",
  "property_seo_description_scheduletour": "\"Explore Overbrook in North Little Rock, AR—your perfect apartment community! Schedule a tour today to experience spacious living, modern amenities, and a welcoming environment. Don’t miss out on your new home!\"",
  "property_seo_title_privacy": "Privacy Policy | Overbrook",
  "property_seo_description_privacy": "Discover how Overbrook Apartments in North Little Rock, AR, prioritizes your privacy. Our comprehensive privacy policy outlines our commitment to safeguarding your personal information. Your trust matters to us—view our privacy policy today for peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | Overbrook",
  "property_seo_description_accessibility": "\"Explore Overbrook's Accessibility Statement to learn how we prioritize digital inclusion for all residents in North Little Rock, AR. Join our community where everyone can thrive—discover more today!\"",
  "property_seo_title_sitemap": "Sitemap | Overbrook",
  "property_seo_description_sitemap": "Discover Overbrook, your ideal apartment community in North Little Rock, AR! Explore our sitemap to easily navigate all our amenities, floor plans, and resident services. View our website sitemap now and plan your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Overbrook",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Overbrook in North Little Rock, AR! Your inquiry is important to us. A member of our dedicated team will be in touch shortly to assist you with your apartment search. Stay tuned for updates on your future home!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in North Little Rock, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293649970",
  "amenities": [
    {
      "id": "ec_0900f5446aec425565df003f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d651d10c025e2fa736f1136",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd6529d1eb68c60cf023f88b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57aaf4277f202aed50351b42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63a00f33bfc92a0500245fa9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21376bc71dc984879dcaf146",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0650b272d4e1eed5966f98b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Freeways and Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9cf1d404a184cee4403eb2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39fd1a6d55e6a90a9d33e345",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8cdcc1120281f2eeb1558c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a32a857d50d52be5d4f6b351",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7ecb17714a65a0004c68875",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call and On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b8624c869d35ddfc448c05d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Courtesy Officers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8096179d56af42c5e705086",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ca0994339cefbc00fb4f8a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_946fd2eda73ab0ff5292878b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94c8b8bb3d6c371589f9b53c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4e093f59595552ae32031b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ed81e4fd729862c505cba6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9d116ba954c5a10ef6e81f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bdf32f294f115f6ed435069",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b922f924f8534b2a97762e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeted Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71d5889885adef38b72419b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_914e6996e49a1e85aabc86a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55b5d6f55727a5a485357d91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Extra Storage*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd576be37a5f469274fb073a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad58021a8dc38ed68ca3d3c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood‑style Flooring*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c956d2fa2fe219cc7154155",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb4d37d36f4db25d5b7bf71b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29d5df93b83d1a3bea5112c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf77b0435190bbd9e0ffac4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ccd13648-2a40-4db4-ab40-87a7d680c395",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-3ef7-76ff-8dca-04f320e9a70e.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with a live-edge wood table, leather chairs, and modern decor.",
        "public_id": "019e6475-3ef7-76ff-8dca-04f320e9a70e",
        "storage_key": "property/6737460151192629/019e6475-3ef7-76ff-8dca-04f320e9a70e.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Experience elegant living in this spacious apartment, featuring a live-edge dining table, comfortable seating, and large windows with scenic views.",
      "link": "",
      "alt_text": "Spacious living and dining area with a live-edge wood table, leather chairs, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7cc95110-6a88-438d-bf58-647e55ac9f53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-03ad-77d4-8ee5-4022c22dae0d.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a stainless steel sink.",
        "public_id": "019fafca-03ad-77d4-8ee5-4022c22dae0d",
        "storage_key": "property/6737460151192629/019fafca-03ad-77d4-8ee5-4022c22dae0d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This apartment kitchen features beautiful dark wood cabinetry, granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b1105f1-aaa5-4610-a334-c303f758616e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-0962-73de-b4e3-b0bdafcdcc16.webp",
      "image_media": {
        "alt_text": "Living room with large sectional sofa, oval coffee table, and decorative wall art.",
        "public_id": "019fafca-0962-73de-b4e3-b0bdafcdcc16",
        "storage_key": "property/6737460151192629/019fafca-0962-73de-b4e3-b0bdafcdcc16.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room, featuring a spacious sectional sofa, a stylish oval coffee table, and unique decorative wall accents.",
      "link": "",
      "alt_text": "Living room with large sectional sofa, oval coffee table, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf6abf6f-a4df-4d0c-837a-76c6c80f071a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-3171-7691-a190-efa7f82b1319.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a poolside building.",
        "public_id": "019e6475-3171-7691-a190-efa7f82b1319",
        "storage_key": "property/6737460151192629/019e6475-3171-7691-a190-efa7f82b1319.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with comfortable lounge chairs and a shaded building for relaxation. Perfect for sunny days!",
      "link": "",
      "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a poolside building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a18c2c79-ccb1-4e62-aff5-2f0349a95d9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-04f9-74b8-b860-fde0541fceb5.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs, artwork on the wall, and a large window.",
        "public_id": "019fafca-04f9-74b8-b860-fde0541fceb5",
        "storage_key": "property/6737460151192629/019fafca-04f9-74b8-b860-fde0541fceb5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table, comfortable seating, and decorative artwork, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a round table and chairs, artwork on the wall, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29e60702-815f-48cb-a223-eafe05162c23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-08f9-710e-9ca8-c31ac83e9280.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and an open door to a bathroom.",
        "public_id": "019fafca-08f9-710e-9ca8-c31ac83e9280",
        "storage_key": "property/6737460151192629/019fafca-08f9-710e-9ca8-c31ac83e9280.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a large dresser with a mirror, and a ceiling fan. An adjoining bathroom is accessible through an open door.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, and an open door to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5301be5-fdb6-4cf9-813a-e10b0a2da155",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-2490-71c2-ad11-1b3d10b970aa.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019e6475-2490-71c2-ad11-1b3d10b970aa",
        "storage_key": "property/6737460151192629/019e6475-2490-71c2-ad11-1b3d10b970aa.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Chic kitchen featuring stainless steel appliances, granite countertops, and ample cabinet storage, perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c269abc-4f87-43f9-8a07-4ee9614b9ab8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-0449-747a-8ca9-4b330944514c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and double closet doors.",
        "public_id": "019fafca-0449-747a-8ca9-4b330944514c",
        "storage_key": "property/6737460151192629/019fafca-0449-747a-8ca9-4b330944514c.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a plush queen-size bed and a convenient ceiling fan for year-round comfort. Ample storage is provided by the double closet doors.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and double closet doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_429b366c-480b-45c5-ba3d-74c78edd26c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-0947-714d-a60d-cffd3b68b7a2.webp",
      "image_media": {
        "alt_text": "Bathroom with shower, toilet, and vanity.",
        "public_id": "019fafca-0947-714d-a60d-cffd3b68b7a2",
        "storage_key": "property/6737460151192629/019fafca-0947-714d-a60d-cffd3b68b7a2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a shower with a decorative curtain, a toilet, and a vanity with a sink and mirror.",
      "link": "",
      "alt_text": "Bathroom with shower, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47438c6b-4fca-4db6-b856-748327fefba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-0394-77d2-bb50-deda06c764bd.webp",
      "image_media": {
        "alt_text": "Stylish living room with a large stone fireplace, unique geometric coffee table, and comfortable seating.",
        "public_id": "019fafca-0394-77d2-bb50-deda06c764bd",
        "storage_key": "property/6737460151192629/019fafca-0394-77d2-bb50-deda06c764bd.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience modern comfort in this beautifully designed living space, featuring a striking stone fireplace and elegant furnishings.",
      "link": "",
      "alt_text": "Stylish living room with a large stone fireplace, unique geometric coffee table, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1984650b-42af-4788-a057-be245237f453",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-04a4-709a-8a2c-298c082414cf.webp",
      "image_media": {
        "alt_text": "Spacious living room with stone fireplace and modern furnishings.",
        "public_id": "019fafca-04a4-709a-8a2c-298c082414cf",
        "storage_key": "property/6737460151192629/019fafca-04a4-709a-8a2c-298c082414cf.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious living room, featuring a stunning stone fireplace and elegant, modern furnishings. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living room with stone fireplace and modern furnishings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4f80a94-ff37-45f9-9eaa-1e92669e89d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-3e50-736f-8924-06f939dd0e70.webp",
      "image_media": {
        "alt_text": "Spacious living area with a large stone fireplace, comfortable seating, and an open kitchen view.",
        "public_id": "019e6475-3e50-736f-8924-06f939dd0e70",
        "storage_key": "property/6737460151192629/019e6475-3e50-736f-8924-06f939dd0e70.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed living spaces, featuring a grand stone fireplace and elegant seating arrangements. An open kitchen view adds to the sophisticated ambiance.",
      "link": "",
      "alt_text": "Spacious living area with a large stone fireplace, comfortable seating, and an open kitchen view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a7a4443-bd2d-4ebc-b07c-d3dcb6f033ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-20cd-73bb-a0c6-ae491b1fe29c.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, desk, and window.",
        "public_id": "019e6475-20cd-73bb-a0c6-ae491b1fe29c",
        "storage_key": "property/6737460151192629/019e6475-20cd-73bb-a0c6-ae491b1fe29c.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable bed, a functional desk, and a large window that lets in natural light.",
      "link": "",
      "alt_text": "Bedroom with a bed, desk, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56a2696d-eca1-4814-8a4a-c33c3e1baa09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-3f91-7199-accd-08aa1a23cef0.webp",
      "image_media": {
        "alt_text": "Modern lounge area with navy blue chairs and accent wall.",
        "public_id": "019e6475-3f91-7199-accd-08aa1a23cef0",
        "storage_key": "property/6737460151192629/019e6475-3f91-7199-accd-08aa1a23cef0.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring comfortable seating and a contemporary design.",
      "link": "",
      "alt_text": "Modern lounge area with navy blue chairs and accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40daa962-5d19-47ac-97de-7e7fca554751",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-0954-72d9-b0e8-e3bcb602bb20.webp",
      "image_media": {
        "alt_text": "Fitness center with various cardio machines, weight machines, and free weights.",
        "public_id": "019fafca-0954-72d9-b0e8-e3bcb602bb20",
        "storage_key": "property/6737460151192629/019fafca-0954-72d9-b0e8-e3bcb602bb20.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with various cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_afb01d2e-6f8f-413a-a705-6add3cc202ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019fafca-0394-77d2-bb50-e2bf63735000.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight benches, and weight rack.",
        "public_id": "019fafca-0394-77d2-bb50-e2bf63735000",
        "storage_key": "property/6737460151192629/019fafca-0394-77d2-bb50-e2bf63735000.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with treadmills, ellipticals, and weight training equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight benches, and weight rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7c9f4ce-6380-4d63-be48-40fbebfb5e6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-3c09-776f-8a06-f90fc9b3b263.webp",
      "image_media": {
        "alt_text": "Lobby seating area with blue armchairs, white side tables, and abstract art on the wall.",
        "public_id": "019e6475-3c09-776f-8a06-f90fc9b3b263",
        "storage_key": "property/6737460151192629/019e6475-3c09-776f-8a06-f90fc9b3b263.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating, modern decor, and a welcoming atmosphere for residents and guests.",
      "link": "",
      "alt_text": "Lobby seating area with blue armchairs, white side tables, and abstract art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6234787c-79f3-4409-8f8d-09bd303ae298",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-26bb-70de-b19b-e777eaffec99.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and access to a bathroom.",
        "public_id": "019e6475-26bb-70de-b19b-e777eaffec99",
        "storage_key": "property/6737460151192629/019e6475-26bb-70de-b19b-e777eaffec99.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, plush carpeting, and a ceiling fan for optimal comfort. Enjoy easy access to the en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and access to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f33489a-61b2-446f-8981-fbe3f0887c8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-396a-749b-92c3-af231495e12e.webp",
      "image_media": {
        "alt_text": "Spacious living room with vaulted ceilings, a fireplace, and an open-concept kitchen.",
        "public_id": "019e6475-396a-749b-92c3-af231495e12e",
        "storage_key": "property/6737460151192629/019e6475-396a-749b-92c3-af231495e12e.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Entertain in style in this expansive living room featuring a stone fireplace, vaulted wood-paneled ceilings, and a seamless flow to the modern kitchen. Perfect for gatherings.",
      "link": "",
      "alt_text": "Spacious living room with vaulted ceilings, a fireplace, and an open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_550ca4b3-e6bf-4fd7-a0f9-6c0ba4e2b625",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-38f4-71fb-b57f-71dc2f3b092a.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and weight equipment",
        "public_id": "019e6475-38f4-71fb-b57f-71dc2f3b092a",
        "storage_key": "property/6737460151192629/019e6475-38f4-71fb-b57f-71dc2f3b092a.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio machines and free weights for a great workout.",
      "link": "",
      "alt_text": "Fitness center with cardio machines and weight equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adbb3355-4979-462a-a027-0e48b65d12f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-2101-755b-9704-50bb72eea4a9.webp",
      "image_media": {
        "alt_text": "Modern living room with sectional sofa, coffee table, floor lamp, and abstract art.",
        "public_id": "019e6475-2101-755b-9704-50bb72eea4a9",
        "storage_key": "property/6737460151192629/019e6475-2101-755b-9704-50bb72eea4a9.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A stylish and comfortable living room featuring a spacious sectional sofa, a unique oval coffee table, and elegant decor, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with sectional sofa, coffee table, floor lamp, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_34a50654-176c-46b1-a9fb-0bb3b3b796a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-39a1-761d-8f84-6f67b774f0b6.webp",
      "image_media": {
        "alt_text": "Playground with slides and tic-tac-toe game.",
        "public_id": "019e6475-39a1-761d-8f84-6f67b774f0b6",
        "storage_key": "property/6737460151192629/019e6475-39a1-761d-8f84-6f67b774f0b6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for families with young children. Featuring slides and an engaging tic-tac-toe game.",
      "link": "",
      "alt_text": "Playground with slides and tic-tac-toe game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ab25f97-143b-4edf-a239-f4e785e8ebf5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-380a-73e2-8b4c-287e9727b7b4.webp",
      "image_media": {
        "alt_text": "Covered picnic pavilion with picnic tables and grills.",
        "public_id": "019e6475-380a-73e2-8b4c-287e9727b7b4",
        "storage_key": "property/6737460151192629/019e6475-380a-73e2-8b4c-287e9727b7b4.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic pavilion, complete with tables and grills for your convenience.",
      "link": "",
      "alt_text": "Covered picnic pavilion with picnic tables and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdea9b23-c8df-498c-9553-b71f0a2b7288",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-28aa-726e-bdaf-17940fa09e7d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and lush greenery.",
        "public_id": "019e6475-28aa-726e-bdaf-17940fa09e7d",
        "storage_key": "property/6737460151192629/019e6475-28aa-726e-bdaf-17940fa09e7d.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed outdoor seating area, complete with a cozy fire pit perfect for evening gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ff104d0-bed1-4b52-86b3-49d1efde0571",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-2e0d-77d2-af42-9a63262b8d88.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with a curved design and a separate seating area with tables and chairs.",
        "public_id": "019e6475-2e0d-77d2-af42-9a63262b8d88",
        "storage_key": "property/6737460151192629/019e6475-2e0d-77d2-af42-9a63262b8d88.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool. The expansive deck area features comfortable seating and tables, perfect for relaxing or socializing outdoors.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with a curved design and a separate seating area with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0aaab1c4-451e-40da-bb1b-f50accb1d3ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e6475-2a67-731d-9c97-f5956144c8fc.webp",
      "image_media": {
        "alt_text": "Playground and covered picnic area with picnic tables.",
        "public_id": "019e6475-2a67-731d-9c97-f5956144c8fc",
        "storage_key": "property/6737460151192629/019e6475-2a67-731d-9c97-f5956144c8fc.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the playground or relax under the covered picnic pavilion, perfect for gatherings.",
      "link": "",
      "alt_text": "Playground and covered picnic area with picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_50335951-a454-4a4f-93dd-2fc6351164ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Larry's Pizza of NLR",
      "poi_type": "Restaurants",
      "poi_address": "5933 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "No-frills local chain restaurant offering lots of specialty pizzas, plus sandwiches & salads.",
      "poi_long_description": "No-frills local chain restaurant offering lots of specialty pizzas, plus sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4b34-7341-9bd7-23c0baf3d052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4b34-7341-9bd7-23c0baf3d052",
        "storage_key": "property/6737460151192629/019e1df4-4b34-7341-9bd7-23c0baf3d052.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "http://larryspizzaofarkansas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17801530169184507833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larrys-pizza-of-nlr",
      "poi_latitude": "34.8098588",
      "poi_longitude": "-92.2483805",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-812-5353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZ3GXbi90ocRuVekUF-9C_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e3430176-7039-4ff0-b958-dd00def6a8ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Littlefields Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6929 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-517b-758e-91f7-a28df62d8191.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-517b-758e-91f7-a28df62d8191",
        "storage_key": "property/6737460151192629/019e1df4-517b-758e-91f7-a28df62d8191.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8138769439472532162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "littlefields-cafe",
      "poi_latitude": "34.8202894",
      "poi_longitude": "-92.23547440000002",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aAnL-i90ocRwrqQJK-38nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_83baa3fc-de7e-4e11-9062-805ab33c41ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "7 Brew Coffee",
      "poi_type": "Restaurants",
      "poi_address": "4900 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Drive-thru cafe dispensing coffee drinks and espressos to go, plus teas, milkshakes and sodas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4ac8-707e-8608-98c5b371dda3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4ac8-707e-8608-98c5b371dda3",
        "storage_key": "property/6737460151192629/019e1df4-4ac8-707e-8608-98c5b371dda3.webp",
        "width": 800,
        "height": 534
      },
      "poi_business_url": "https://7brew.com/location/arkansas-north-little-rock-000140",
      "poi_directions_map_url": "https://maps.google.com/?cid=4563517196262563638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-brew-coffee",
      "poi_latitude": "34.8006",
      "poi_longitude": "-92.2546785",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-358-9274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-992f-709b-b538-ec28dd27f35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-992f-709b-b538-ec28dd27f35c",
        "storage_key": "property/6737460151192629/019e1df4-992f-709b-b538-ec28dd27f35c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJN3eQ8w290ocRNt-dIbbeVD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_2635e0d6-4b0c-450c-8e99-aa887e642cb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Dark Side Coffee Lounge",
      "poi_type": "Restaurants",
      "poi_address": "3515 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Casual, Star Wars-themed cafe featuring roasted java, pastries and cozy seating, plus drive-thru service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4f98-751b-bfc4-85582c13a575.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4f98-751b-bfc4-85582c13a575",
        "storage_key": "property/6737460151192629/019e1df4-4f98-751b-bfc4-85582c13a575.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dscoffee.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14326907618640493248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dark-side-coffee-lounge",
      "poi_latitude": "34.787588",
      "poi_longitude": "-92.2606827",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-992f-709b-b538-ec28dd27f35c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-992f-709b-b538-ec28dd27f35c",
        "storage_key": "property/6737460151192629/019e1df4-992f-709b-b538-ec28dd27f35c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJnd0k6DK90ocRwHrnapJm08Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_dd977a93-f2d0-4d7f-b8ce-4be0ef63fbde",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Fujiyama Express JFK",
      "poi_type": "Restaurants",
      "poi_address": "3700 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Cozy locale offering sushi and other Japanese dishes, including vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4c7e-77be-808f-be9432f50460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4c7e-77be-808f-be9432f50460",
        "storage_key": "property/6737460151192629/019e1df4-4c7e-77be-808f-be9432f50460.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.doordash.com/store/fujiyama-express-north-little-rock-2743319/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18181461295692875509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fujiyama-express-jfk",
      "poi_latitude": "34.7893108",
      "poi_longitude": "-92.2601937",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-297-0458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZe7Sla90ocR9YZJC7iGUfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3b7a5d3f-e938-49b9-b5bf-25f3bb920e90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Brood and Barley",
      "poi_type": "Restaurants",
      "poi_address": "411 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Casual gastropub specializing in sliders, burgers and steaks, plus beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4ac7-730f-b8cf-7d124f5fe914.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4ac7-730f-b8cf-7d124f5fe914",
        "storage_key": "property/6737460151192629/019e1df4-4ac7-730f-b8cf-7d124f5fe914.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broodandbarley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11202043947735015600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brood-and-barley",
      "poi_latitude": "34.7575145",
      "poi_longitude": "-92.2678324",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-400-8967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6872-705c-8952-630863bfb6b0",
        "storage_key": "property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_-HGX690ocRsGAPl56ndZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "custom_bdcd19e4-6379-40d3-845c-bc1eaadaa932",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Flyway Brewing",
      "poi_type": "Restaurants",
      "poi_address": "314 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4b2b-76db-89a0-77477fc38495.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4b2b-76db-89a0-77477fc38495",
        "storage_key": "property/6737460151192629/019e1df4-4b2b-76db-89a0-77477fc38495.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywaybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212740221938584033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flyway-brewing",
      "poi_latitude": "34.7567912",
      "poi_longitude": "-92.2688016",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-812-3192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yyyxIO80ocR4UmasGs62n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_c798aab2-0d1d-4ec3-8f86-14b8a618e632",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Four Quarter Bar",
      "poi_type": "Restaurants",
      "poi_address": "415 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Pub fare like house-smoked pork served in chill digs with a full bar, live weekend music & a patio.",
      "poi_long_description": "Pub fare like house-smoked pork served in chill digs with a full bar, live weekend music & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-511c-76bd-b1c3-2ff0156eec58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-511c-76bd-b1c3-2ff0156eec58",
        "storage_key": "property/6737460151192629/019e1df4-511c-76bd-b1c3-2ff0156eec58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fourquarterbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9814059172389972854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-quarter-bar",
      "poi_latitude": "34.75767390000001",
      "poi_longitude": "-92.2679825",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-313-4704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6872-705c-8952-630863bfb6b0",
        "storage_key": "property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-V54oO80ocRduv39tGKMog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_219ae229-e750-4b6f-92dd-7b00edb1804e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Crush Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "318 N Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Chill spot boasting a selection of wine, cheese and meat platters served by friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4a35-75c6-8683-686b8bb4e7d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4a35-75c6-8683-686b8bb4e7d1",
        "storage_key": "property/6737460151192629/019e1df4-4a35-75c6-8683-686b8bb4e7d1.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.facebook.com/pages/Crush-Wine-Bar/166280556769443",
      "poi_directions_map_url": "https://maps.google.com/?cid=201777118372375007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crush-wine-bar",
      "poi_latitude": "34.756795",
      "poi_longitude": "-92.2675973",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-374-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6872-705c-8952-630863bfb6b0",
        "storage_key": "property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5eAcHy70ocR3yljWDjbzAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_b2c91e7e-5de8-42d9-bddb-23d17532d478",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Reno's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "312 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Neighborhood hangout offering sandwiches, gyros & pizzas, plus a full bar & live music on weekends.",
      "poi_long_description": "Neighborhood hangout offering sandwiches, gyros & pizzas, plus a full bar & live music on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-4ecd-75dc-af45-676b7f601290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-4ecd-75dc-af45-676b7f601290",
        "storage_key": "property/6737460151192629/019e1df4-4ecd-75dc-af45-676b7f601290.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://renoscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14858137782810764992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renos-cafe",
      "poi_latitude": "34.7566161",
      "poi_longitude": "-92.2675925",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-376-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6872-705c-8952-630863bfb6b0",
        "storage_key": "property/6737460151192629/019e1df2-6872-705c-8952-630863bfb6b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT31EZYG80ocRwOY-eJe1Ms4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_8be3b7ad-1e05-4c77-9c98-4a90075d9e19",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Raduno | Brick Oven & Barroom",
      "poi_type": "Restaurants",
      "poi_address": "1318 S Main St Suite 100, Little Rock, AR 72202, USA",
      "poi_short_description": "Pizza & an Italian-inspired menu with banquette & bar seating in a relaxed, family-friendly setting.",
      "poi_long_description": "Pizza & an Italian-inspired menu with banquette & bar seating in a relaxed, family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-535d-7198-a4d6-331b2df92c10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-535d-7198-a4d6-331b2df92c10",
        "storage_key": "property/6737460151192629/019e1df4-535d-7198-a4d6-331b2df92c10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://radunolr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17346456726356156823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raduno--brick-oven--barroom",
      "poi_latitude": "34.7358004",
      "poi_longitude": "-92.2731378",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-374-7476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22_QB3K70ocRl-Ektnz-uvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7e2423b6-0d6a-4cab-9105-310bce91928e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "El Sur Street Food Co",
      "poi_type": "Restaurants",
      "poi_address": "1214 Main St, Little Rock, AR 72202, USA",
      "poi_short_description": "Relaxed venue offering Honduran eats, plus games such as ping pong, pool and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-54ff-77f8-a7e8-8b6a1f423cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-54ff-77f8-a7e8-8b6a1f423cb6",
        "storage_key": "property/6737460151192629/019e1df4-54ff-77f8-a7e8-8b6a1f423cb6.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "http://www.elsurstreetfoodco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7828488338912195401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-sur-street-food-co",
      "poi_latitude": "34.7367753",
      "poi_longitude": "-92.2729262",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-812-3066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZHYwlu70ocRSTMmyapgpGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_593600de-3107-4a76-a7a1-72369e03950a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "The Root Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1500 Main St, Little Rock, AR 72202, USA",
      "poi_short_description": "Chill cafe with a patio offering sandwiches & salads made with locally sourced ingredients.",
      "poi_long_description": "Chill cafe with a patio offering sandwiches & salads made with locally sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-2a0f-745f-bdb1-e9baaebc2f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-2a0f-745f-bdb1-e9baaebc2f00",
        "storage_key": "property/6737460151192629/019e1df2-2a0f-745f-bdb1-e9baaebc2f00.webp",
        "width": 1277,
        "height": 473
      },
      "poi_business_url": "http://www.therootcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2097092921480150968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-root-cafe",
      "poi_latitude": "34.7342088",
      "poi_longitude": "-92.2735047",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-414-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0GAiG270ocRuH_PteZeGh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3cc156ca-91ef-4280-8c1d-2990fc1a04f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Flying Fish",
      "poi_type": "Restaurants",
      "poi_address": "511 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Laid-back eatery serving seafood with a Cajun twist, from fried catfish to po' boy sandwiches.",
      "poi_long_description": "Laid-back eatery serving seafood with a Cajun twist, from fried catfish to po' boy sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5753-7239-9cc3-e7b579b059b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5753-7239-9cc3-e7b579b059b9",
        "storage_key": "property/6737460151192629/019e1df4-5753-7239-9cc3-e7b579b059b9.webp",
        "width": 1071,
        "height": 573
      },
      "poi_business_url": "https://www.flyingfishinthe.net/little-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15399250899550809109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-fish",
      "poi_latitude": "34.7471349",
      "poi_longitude": "-92.265086",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZJE1Hi70ocRFSzXuhohtdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_7c56253c-a1f6-4adc-b333-3aa6c7053459",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Gus's World Famous Fried Chicken",
      "poi_type": "Restaurants",
      "poi_address": "300 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Long-running chain serving spicy fried chicken & comfort sides in a low-key setting.",
      "poi_long_description": "Long-running chain serving spicy fried chicken & comfort sides in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-563f-7065-a2e0-97ebd78755e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-563f-7065-a2e0-97ebd78755e5",
        "storage_key": "property/6737460151192629/019e1df4-563f-7065-a2e0-97ebd78755e5.webp",
        "width": 961,
        "height": 640
      },
      "poi_business_url": "http://gusfriedchicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3088786990121259922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guss-world-famous-fried-chicken",
      "poi_latitude": "34.7477944",
      "poi_longitude": "-92.2674378",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-372-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8aVMqn670ocRkpMGBWeT3So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_bbed96b1-d4a8-48dc-8b6f-5868b7d02fb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "6929 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-2a0a-726c-a79c-cc163997f040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-2a0a-726c-a79c-cc163997f040",
        "storage_key": "property/6737460151192629/019e1df2-2a0a-726c-a79c-cc163997f040.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ar/north-little-rock/indian-hills/025/00642?cid=loc_02500642_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18224838640056878914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.819685",
      "poi_longitude": "-92.2385138",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-835-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-688a-771e-bae7-cbc7f8e960d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-688a-771e-bae7-cbc7f8e960d3",
        "storage_key": "property/6737460151192629/019e1df2-688a-771e-bae7-cbc7f8e960d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWk1Kei90ocRQkdnDS-i6_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_97ba1f10-f1f8-42f0-883f-e30338f61da6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Medicine Man Pharmacy JFK",
      "poi_type": "Shopping & Retail",
      "poi_address": "5308 John F Kennedy Blvd Ste 3, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5a69-7194-b613-70fcf80bc017.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5a69-7194-b613-70fcf80bc017",
        "storage_key": "property/6737460151192629/019e1df4-5a69-7194-b613-70fcf80bc017.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "http://www.rxmedman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=834275891562115446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medicine-man-pharmacy-jfk",
      "poi_latitude": "34.803548",
      "poi_longitude": "-92.253165",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-907-2095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-9922-70ce-8c87-3a6913865937",
        "storage_key": "property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkfG8_bG90ocRdnE70YDxkws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ca245eb4-f0c1-4ecc-9cb9-fe69c31f773e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4823 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5c67-75c8-833f-7260100bc149.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5c67-75c8-833f-7260100bc149",
        "storage_key": "property/6737460151192629/019e1df4-5c67-75c8-833f-7260100bc149.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4823+john+f+kennedy+blvd-north+little+rock-ar-72116/id=3416",
      "poi_directions_map_url": "https://maps.google.com/?cid=16809595157491161868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.79976360000001",
      "poi_longitude": "-92.25572710000002",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-771-1971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2Xt_ay90ocRDBtjFLytR-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8afd8bc4-10f3-40cb-9add-170ba32c1418",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "4613 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5c6f-77f8-82ef-0e35d725c92e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5c6f-77f8-82ef-0e35d725c92e",
        "storage_key": "property/6737460151192629/019e1df4-5c6f-77f8-82ef-0e35d725c92e.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/north-little-rock/4156",
      "poi_directions_map_url": "https://maps.google.com/?cid=8463519931787597148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "34.7973336",
      "poi_longitude": "-92.2568081",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-313-3270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6829-76cd-91ec-e034fc919ac3",
        "storage_key": "property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdSIyrR4UIBURXFWjS4l2dHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_111f0356-79a5-412f-93cf-369addf069fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Maverik",
      "poi_type": "Shopping & Retail",
      "poi_address": "5216 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Gas station & convenience store chain offering hot & cold snacks, plus coffees & sodas.",
      "poi_long_description": "Gas station & convenience store chain offering hot & cold snacks, plus coffees & sodas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5f1c-75dc-9550-996f9f66928b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5f1c-75dc-9550-996f9f66928b",
        "storage_key": "property/6737460151192629/019e1df4-5f1c-75dc-9550-996f9f66928b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.maverik.com/ar/north-little-rock/5216-jfk-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=10884108417569703044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik",
      "poi_latitude": "34.8028355",
      "poi_longitude": "-92.2531742",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-975-1603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-992e-745f-887f-3682b14a0cb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-992e-745f-887f-3682b14a0cb5",
        "storage_key": "property/6737460151192629/019e1df4-992e-745f-887f-3682b14a0cb5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVo8_K290ocRhMQUdvAeDJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_5987ac96-3b1d-4532-a8b6-3569dd0bfd4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "McCain Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3929 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Sheltered complex featuring major & boutique stores, services & a variety of dining options.",
      "poi_long_description": "Sheltered complex featuring major & boutique stores, services & a variety of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-2d60-77c9-9e92-fccffb4c2f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-2d60-77c9-9e92-fccffb4c2f1e",
        "storage_key": "property/6737460151192629/019e1df2-2d60-77c9-9e92-fccffb4c2f1e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/mccain-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=5997340656104035792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccain-mall",
      "poi_latitude": "34.7928004",
      "poi_longitude": "-92.2265383",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-758-6340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6829-76cd-91ec-e034fc919ac3",
        "storage_key": "property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRbuB2iu80ocR0NUWLI3VOlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_820af1be-0b8b-4f45-a4ec-f5aba5c5b29d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-60a6-75e4-ab36-9647090f785f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-60a6-75e4-ab36-9647090f785f",
        "storage_key": "property/6737460151192629/019e1df4-60a6-75e4-ab36-9647090f785f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/little-rock-north/162",
      "poi_directions_map_url": "https://maps.google.com/?cid=5304223806694593745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.7880996",
      "poi_longitude": "-92.2290477",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-771-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6829-76cd-91ec-e034fc919ac3",
        "storage_key": "property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBZfj0Si80ocR0ZQz_3JjnEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7cec2973-3420-41d4-a5ca-d5b0fb550b0e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2808 Lakewood Village Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5e7a-775f-8edb-7b239943d078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5e7a-775f-8edb-7b239943d078",
        "storage_key": "property/6737460151192629/019e1df4-5e7a-775f-8edb-7b239943d078.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ar/north-little-rock/2808-lakewood-village-dr?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5186531015405354609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.794697",
      "poi_longitude": "-92.2328978",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-859-9455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6829-76cd-91ec-e034fc919ac3",
        "storage_key": "property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxYY1Iy280ocRcT7IpXpC-kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_3684b039-5508-4b6e-8b49-6b4d82c18d27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Pike Plz Shp Ctr, 2633 Pike Ave, North Little Rock, AR 72114, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-60cf-73aa-8a05-7807bdeec935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-60cf-73aa-8a05-7807bdeec935",
        "storage_key": "property/6737460151192629/019e1df4-60cf-73aa-8a05-7807bdeec935.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ar/n-little-rock/2633-pike-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9418126316155455969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "34.7795147",
      "poi_longitude": "-92.2795917",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-291-1996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6829-76cd-91ec-e034fc919ac3",
        "storage_key": "property/6737460151192629/019e1df2-6829-76cd-91ec-e034fc919ac3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa1maAOy80ocR4Uk0NPzns4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_14b9e54a-d74f-47dd-8feb-b6410cca4db5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Central Arkansas Christian Schools",
      "poi_type": "Education",
      "poi_address": "6101 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6119-7671-becd-99987b7a237b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6119-7671-becd-99987b7a237b",
        "storage_key": "property/6737460151192629/019e1df4-6119-7671-becd-99987b7a237b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cacmustangs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15464187513231867807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arkansas-christian-schools",
      "poi_latitude": "34.812085",
      "poi_longitude": "-92.2446152",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-758-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNbW58ri90ocRn383SpzUm9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_24e918ba-4f2d-468c-9517-4e0324d29faf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "JFK EARLY LEARNING CENTER INC",
      "poi_type": "Education",
      "poi_address": "6201 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.facebook.com/pages/Jfk-Early-Learning-Center/159679017397396",
      "poi_directions_map_url": "https://maps.google.com/?cid=17790030755178693077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jfk-early-learning-center-inc",
      "poi_latitude": "34.8132606",
      "poi_longitude": "-92.2425143",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-834-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ42IERMe90ocR1UGzWbfi4vY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_8f484194-9fa8-43d6-b11c-7f11516d2a21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Park Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6260-767b-88ec-188eccee22e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6260-767b-88ec-188eccee22e2",
        "storage_key": "property/6737460151192629/019e1df4-6260-767b-88ec-188eccee22e2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1556490651594456202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-hill-elementary-school",
      "poi_latitude": "34.790569",
      "poi_longitude": "-92.2607368",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-771-8175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6l981a80ocRivyAQADEmRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_0585a117-caa6-4377-8920-5ade14e1781a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Pike View Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "441 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6381-72c4-98b1-49d89abb511c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6381-72c4-98b1-49d89abb511c",
        "storage_key": "property/6737460151192629/019e1df4-6381-72c4-98b1-49d89abb511c.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "http://nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1828821698467831290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pike-view-early-childhood-center",
      "poi_latitude": "34.8016235",
      "poi_longitude": "-92.2607826",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-771-8170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW39lDAC90ocR-p2zLqVHYRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_5b3d2552-59e6-4b29-adb7-6151727830a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Ridge Road Elementary School",
      "poi_type": "Education",
      "poi_address": "4601 Ridge Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6453-7042-ba61-afe23e392fd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6453-7042-ba61-afe23e392fd9",
        "storage_key": "property/6737460151192629/019e1df4-6453-7042-ba61-afe23e392fd9.webp",
        "width": 1280,
        "height": 973
      },
      "poi_business_url": "http://www.nlrsd.org/o/ridge-road-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=1931544893243447523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridge-road-elementary-school",
      "poi_latitude": "34.7964938",
      "poi_longitude": "-92.2652928",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-771-8155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7wdHw_-80ocR49h-vdg5zho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a5f5d020-554b-4c08-9728-285306e54f0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Crestwood Elementary School",
      "poi_type": "Education",
      "poi_address": "1901 Crestwood Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-661f-752b-9f4d-7fb3d79df980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-661f-752b-9f4d-7fb3d79df980",
        "storage_key": "property/6737460151192629/019e1df4-661f-752b-9f4d-7fb3d79df980.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nlrsd.org/o/crestwood-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=2389178650490793637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crestwood-elementary-school",
      "poi_latitude": "34.8037337",
      "poi_longitude": "-92.2441375",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-771-8190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVfhRDra90ocRpW5z_1IRKCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fa1f1c83-1463-4db7-9f43-bdb5162cf700",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "North Little Rock Middle School",
      "poi_type": "Education",
      "poi_address": "2400 Lakeview Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=244976341614849333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-middle-school",
      "poi_latitude": "34.787885",
      "poi_longitude": "-92.231354",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-771-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSdGgvjq80ocRNe1TTK9UZgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f08a6415-0eb8-42ad-a297-2a25ff07e51f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "North Little Rock High School",
      "poi_type": "Education",
      "poi_address": "201 W 22nd St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-668e-75ba-9e5e-9a29bb8b2c9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-668e-75ba-9e5e-9a29bb8b2c9e",
        "storage_key": "property/6737460151192629/019e1df4-668e-75ba-9e5e-9a29bb8b2c9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8188116334975508691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-high-school",
      "poi_latitude": "34.776321",
      "poi_longitude": "-92.269072",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-771-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdaP0tvS80ocR0-DJlWwIonE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_da699fa0-7178-4fd5-b6f7-c7fd5ac83fb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "University of Arkansas – Pulaski Technical College",
      "poi_type": "Education",
      "poi_address": "3000 W Scenic Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-35fd-76d9-858f-175a85f00e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-35fd-76d9-858f-175a85f00e74",
        "storage_key": "property/6737460151192629/019e1df2-35fd-76d9-858f-175a85f00e74.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.uaptc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3922972585545535160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas--pulaski-technical-college",
      "poi_latitude": "34.78212980000001",
      "poi_longitude": "-92.2993636",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-812-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ_E4js280ocRuI4JIcgycTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_35173d79-3208-4b92-85f9-b9138eafd96f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Arkansas Inland Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "120 Riverfront Park Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_long_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-65de-738f-a619-1f6d7423f8ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-65de-738f-a619-1f6d7423f8ce",
        "storage_key": "property/6737460151192629/019e1df4-65de-738f-a619-1f6d7423f8ce.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/arkansas-inland-maritime-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401581648013172689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-inland-maritime-museum",
      "poi_latitude": "34.7522251",
      "poi_longitude": "-92.2669543",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-371-8320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-688e-752e-a299-a488f6c19cb1",
        "storage_key": "property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHa_JEH670ocR0R-oeLIgeYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_00fbdb8a-4d2b-4761-98bd-e12d4634e00e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Argenta Contemporary Theatre",
      "poi_type": "Entertainment",
      "poi_address": "405 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Nonprofit organization presenting a variety of performing arts productions for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6903-7442-9b9e-b79d69220351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6903-7442-9b9e-b79d69220351",
        "storage_key": "property/6737460151192629/019e1df4-6903-7442-9b9e-b79d69220351.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://argentacontemporarytheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5638920590178178111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argenta-contemporary-theatre",
      "poi_latitude": "34.7573812",
      "poi_longitude": "-92.2679905",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-353-1443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWbK4YO80ocRP9Q0hmZ4QU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_af5cc4d8-8c5c-4b44-ba9d-b339750d565c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Regal McCain Mall",
      "poi_type": "Entertainment",
      "poi_address": "3929 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6a85-76cb-ac20-ae035bc9609d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6a85-76cb-ac20-ae035bc9609d",
        "storage_key": "property/6737460151192629/019e1df4-6a85-76cb-ac20-ae035bc9609d.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-mccain-mall-0541?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8580205952362246530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-mccain-mall",
      "poi_latitude": "34.79336",
      "poi_longitude": "-92.227005",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9925-70d2-91c0-3a855d5fa4b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-9925-70d2-91c0-3a855d5fa4b1",
        "storage_key": "property/6737460151192629/019e1df4-9925-70d2-91c0-3a855d5fa4b1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJxyek4Cu80ocRgnE-ktoDE3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e6aadf7b-5a23-46c8-9345-68117e3d3d8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Museum of Discovery",
      "poi_type": "Entertainment",
      "poi_address": "500 President Clinton Ave Ste. 150, Little Rock, AR 72201, USA",
      "poi_short_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_long_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-3d21-760f-9d5e-ec86c015aa27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-3d21-760f-9d5e-ec86c015aa27",
        "storage_key": "property/6737460151192629/019e1df2-3d21-760f-9d5e-ec86c015aa27.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.museumofdiscovery.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16338434694446452897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery",
      "poi_latitude": "34.7476729",
      "poi_longitude": "-92.2646549",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-396-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-688e-752e-a299-a488f6c19cb1",
        "storage_key": "property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUmT0ni70ocRoRBmNMrHveI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b85be3e6-d1f8-4c0e-9bc6-e3580a6c1af7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "William J. Clinton Library and Museum",
      "poi_type": "Entertainment",
      "poi_address": "1200 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_long_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-3433-7422-a600-69b0b10ba348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-3433-7422-a600-69b0b10ba348",
        "storage_key": "property/6737460151192629/019e1df2-3433-7422-a600-69b0b10ba348.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.clintonpresidentialcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8035004359637958132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-clinton-library-and-museum",
      "poi_latitude": "34.7464097",
      "poi_longitude": "-92.2583824",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-370-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-688e-752e-a299-a488f6c19cb1",
        "storage_key": "property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsmz4O70ocR9H3v0OQRgm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_61ea16f4-b42c-4a92-8f72-0e3213e06134",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Old State House Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "National Historic Landmark building featuring permanent & traveling exhibits on Arkansas history.",
      "poi_long_description": "National Historic Landmark building featuring permanent & traveling exhibits on Arkansas history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-70a9-71a5-bbf9-69e4e0061351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-70a9-71a5-bbf9-69e4e0061351",
        "storage_key": "property/6737460151192629/019e1df4-70a9-71a5-bbf9-69e4e0061351.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.oldstatehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4679743598728721160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-state-house-museum",
      "poi_latitude": "34.7490498",
      "poi_longitude": "-92.2725927",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-324-9685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-688e-752e-a299-a488f6c19cb1",
        "storage_key": "property/6737460151192629/019e1df2-688e-752e-a299-a488f6c19cb1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJm453s3y70ocRCDMiOgLK8UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_868f95ac-cacf-46bc-99d6-203d7e7ce848",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Little Rock Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1 Zoo Dr, Little Rock, AR 72205, USA",
      "poi_short_description": "This 33-acre zoo displays more than 700 animals & has a train, antique carousel & playground.",
      "poi_long_description": "This 33-acre zoo displays more than 700 animals & has a train, antique carousel & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6a81-755f-8a6d-784d166412de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6a81-755f-8a6d-784d166412de",
        "storage_key": "property/6737460151192629/019e1df4-6a81-755f-8a6d-784d166412de.webp",
        "width": 641,
        "height": 360
      },
      "poi_business_url": "http://www.littlerockzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8740204647355742622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-zoo",
      "poi_latitude": "34.7468773",
      "poi_longitude": "-92.3302705",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-661-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdcYL5yk0ocRnnnbtdFxS3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_bf4f426d-d334-4d47-b212-b93b1dec5487",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Ottenheimer Market Hall",
      "poi_type": "Entertainment",
      "poi_address": "400 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Eatery in the River Market Pavilions featuring a large variety of comfort food and small plates, plus coffee, cocktails, and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6ce3-762b-a153-eee256606571.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6ce3-762b-a153-eee256606571",
        "storage_key": "property/6737460151192629/019e1df4-6ce3-762b-a153-eee256606571.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9513936606056685095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ottenheimer-market-hall",
      "poi_latitude": "34.7476913",
      "poi_longitude": "-92.2661168",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0QbY0n670ocRJx6Yq-9KCIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4769a71f-99a0-47e6-a260-2b73c02fc4fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 Springhill Dr, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6ec9-71fd-ba1e-1b91a9ec059a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6ec9-71fd-ba1e-1b91a9ec059a",
        "storage_key": "property/6737460151192629/019e1df4-6ec9-71fd-ba1e-1b91a9ec059a.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.baptist-health.com/find-care/location/baptist-health-medical-center-north-little-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12673750733774113147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-north-little-rock",
      "poi_latitude": "34.7835092",
      "poi_longitude": "-92.2224382",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-202-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682a-7489-8dfa-98f095b8f20d",
        "storage_key": "property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23mhdJ2-0ocRe8lz2iQ14q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e1cac316-3540-4551-844f-b12fc5cbe54b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "MedExpress Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "5505 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-7002-7238-a7b6-c655991cb37a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-7002-7238-a7b6-c655991cb37a",
        "storage_key": "property/6737460151192629/019e1df4-7002-7238-a7b6-c655991cb37a.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.medexpress.com/?utm_campaign=MX_Brand_2021&utm_medium=NPS&utm_source=YEXT&utm_term=2021fcliq3az19",
      "poi_directions_map_url": "https://maps.google.com/?cid=13519058874553291009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medexpress-urgent-care",
      "poi_latitude": "34.8057228",
      "poi_longitude": "-92.2525551",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 304-225-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ67290rG90ocRAVFXW2tYnbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_028b4248-f200-4d38-8382-19a25b3f81a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Cornerstone Pharmacy JFK",
      "poi_type": "Health and Wellness",
      "poi_address": "5328 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-5b67-7106-bb2d-6ed56b3fa196.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-5b67-7106-bb2d-6ed56b3fa196",
        "storage_key": "property/6737460151192629/019e1df4-5b67-7106-bb2d-6ed56b3fa196.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cornerstonepharmacy.com/cornerstone-pharmacy-locations/cornerstone-pharmacy-jfk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796893712413055146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornerstone-pharmacy-jfk",
      "poi_latitude": "34.8046175",
      "poi_longitude": "-92.2525419",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-246-5035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-9922-70ce-8c87-3a6913865937",
        "storage_key": "property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVtKw7G90ocRqljDGYpE-_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_55448148-a255-449e-9d5f-93b4ab44f793",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6929 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-76c5-7269-b3e6-94066837c473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-76c5-7269-b3e6-94066837c473",
        "storage_key": "property/6737460151192629/019e1df4-76c5-7269-b3e6-94066837c473.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/025/00642?cid=loc_02500642P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7543603801793653785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "34.8193481",
      "poi_longitude": "-92.2388881",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-835-6530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-9922-70ce-8c87-3a6913865937",
        "storage_key": "property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnW41Kei90ocRGWwypLBDsGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_da0bccc7-df55-4fcc-b68b-0ae64f338c32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4823 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-7a72-7515-957c-cd77e96dc6fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-7a72-7515-957c-cd77e96dc6fe",
        "storage_key": "property/6737460151192629/019e1df4-7a72-7515-957c-cd77e96dc6fe.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4823+john+f+kennedy+blvd-north+little+rock-ar-72116/id=3416",
      "poi_directions_map_url": "https://maps.google.com/?cid=14062564384778763998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "34.7998668",
      "poi_longitude": "-92.2556192",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-771-1971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-9922-70ce-8c87-3a6913865937",
        "storage_key": "property/6737460151192629/019e1df4-9922-70ce-8c87-3a6913865937.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhevL_ay90ocR3j7MIc1DKMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9479d9d6-54a3-4503-9ebc-2e94f44143d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-782c-72ed-b087-56c8472989a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-782c-72ed-b087-56c8472989a2",
        "storage_key": "property/6737460151192629/019e1df4-782c-72ed-b087-56c8472989a2.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-little-rock-ar-pharmacies/2501-mccain-blvd-north-little-rock-ar-72116/storeid=10975?WT.mc_id=LS_GOOGLE_FS_10975",
      "poi_directions_map_url": "https://maps.google.com/?cid=4323128636093777376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "34.797678",
      "poi_longitude": "-92.237715",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-404-6059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyB8GW290ocR4EWw8JbW_js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bd1066f1-c5a2-479b-9fb8-46eaef5e3dd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "10 Fitness North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "6929 John F Kennedy Blvd Suite 110, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain fitness center offering equipment and personal training in the Indian Hills Shopping Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-44d2-769a-8acd-d91f50ff9159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-44d2-769a-8acd-d91f50ff9159",
        "storage_key": "property/6737460151192629/019e1df2-44d2-769a-8acd-d91f50ff9159.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://10fitness.com/locations/north-little-rock/?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=15697803304372877289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "10-fitness-north-little-rock",
      "poi_latitude": "34.8201337",
      "poi_longitude": "-92.2378954",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-834-8866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJySl1yPq90ocR6TcZT-_M2dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_702a95f2-a5b6-49da-8bdb-8957a04e8eb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4617 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain gym with tanning beds and hydromassage in North Park Mall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-3ef8-74ef-bb14-4b5244730f12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-3ef8-74ef-bb14-4b5244730f12",
        "storage_key": "property/6737460151192629/019e1df2-3ef8-74ef-bb14-4b5244730f12.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/north-little-rock-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7560349064309511589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.7976804",
      "poi_longitude": "-92.2567809",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-377-9535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSttMYK90ocRpRUg5GrB62g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_552389c7-6d3b-47ad-9333-d38cb334b609",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Blue Yoga Nyla",
      "poi_type": "Health and Wellness",
      "poi_address": "3721 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.blueyoganyla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8960569883019740698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-yoga-nyla",
      "poi_latitude": "34.789767",
      "poi_longitude": "-92.260687",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh8JtWQC90ocRGoZ0XtVWWnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_8b76bd17-1825-4f8e-b452-488b73e9d4c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "YMCA Child Development Center - North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "3335 Springhill Dr, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ymcamemphis.org/micro-site-child-care/north-little-rock-ymca-child-development-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13914089397756943320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-child-development-center---north-little-rock",
      "poi_latitude": "34.786264",
      "poi_longitude": "-92.2222181",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-500-6162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv3AQ06e_0ocR2NtUVpbGGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_5d7e5e34-55db-4960-ba42-6c490b00d0ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Idlewild Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3411 Idlewild Ave, North Little Rock, AR 72116, USA",
      "poi_short_description": "Peaceful park featuring a tennis court, basketball court, and a children's playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-782c-72ed-b087-5045803ebdad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-782c-72ed-b087-5045803ebdad",
        "storage_key": "property/6737460151192629/019e1df4-782c-72ed-b087-5045803ebdad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/idlewild-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1762240858135831597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "idlewild-park",
      "poi_latitude": "34.7867052",
      "poi_longitude": "-92.2566643",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-791-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVAymVC80ocRLaTdRbm8dBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fcb6f1aa-2d97-4d5b-b5ad-51abe97e83b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "The Old Mill",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3800 Lakeshore Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_long_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-3f7b-7069-ac79-094a68cf9218.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-3f7b-7069-ac79-094a68cf9218",
        "storage_key": "property/6737460151192629/019e1df2-3f7b-7069-ac79-094a68cf9218.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/old-mill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753738084307160303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-old-mill",
      "poi_latitude": "34.7913123",
      "poi_longitude": "-92.249526",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Xsnok680ocR78zj0OoX374",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_4253da23-cdd3-4f7e-a2cb-8694516b5b7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Burns Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Little Rock, AR 72118, USA",
      "poi_short_description": "Park offering ball fields, a 36-hole golf course, multi-use trails & fishing in the Arkansas River.",
      "poi_long_description": "Park offering ball fields, a 36-hole golf course, multi-use trails & fishing in the Arkansas River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-7d3b-778c-9d9c-62bf5a512f0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-7d3b-778c-9d9c-62bf5a512f0d",
        "storage_key": "property/6737460151192629/019e1df4-7d3b-778c-9d9c-62bf5a512f0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/burns-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18303069099405761385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-park",
      "poi_latitude": "34.7976957",
      "poi_longitude": "-92.3099177",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXtiMt-i0ocRaVuCQV-QAf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6b9da93-bf02-4298-821b-47b51cdb3e70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "One Heart Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11 Funland Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "Play space with multiple large structures, slides, a tank to climb on and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-7db8-7600-86ba-2235ecc5c3a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-7db8-7600-86ba-2235ecc5c3a3",
        "storage_key": "property/6737460151192629/019e1df4-7db8-7600-86ba-2235ecc5c3a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/community-facilities/inclusive-playgrounds/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3498936699690686089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-heart-playground",
      "poi_latitude": "34.8016739",
      "poi_longitude": "-92.3031417",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8x1ptSi0ocRiRak5GO4jjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_e6d923d7-e132-4069-845e-ad3cf5fd13e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Burns Park Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4200 Joe Poch Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Fenced and shaded park with separate areas for small and large dogs, plus waste bags and water troughs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-7da3-736f-befd-02016a3e6feb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-7da3-736f-befd-02016a3e6feb",
        "storage_key": "property/6737460151192629/019e1df4-7da3-736f-befd-02016a3e6feb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17003103229511555546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-park-dog-park",
      "poi_latitude": "34.8045224",
      "poi_longitude": "-92.307369",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-791-8540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_UtXB-j0ocR2llVCk0o9-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_d2421d2e-b759-4d86-ab45-ecf462b83462",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Big Dam Bridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_long_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-7b4f-7694-850d-c56255a48003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-7b4f-7694-850d-c56255a48003",
        "storage_key": "property/6737460151192629/019e1df4-7b4f-7694-850d-c56255a48003.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17869723390477343867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-dam-bridge",
      "poi_latitude": "34.7925668",
      "poi_longitude": "-92.3584127",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GbOUyi0ocRexzk674C_vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_9eaf77f6-dea8-476f-9d53-f68632e240f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Campbell Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4100 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Park with paved riverside trails for walking, running, and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-8267-705e-abd3-36744c666ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-8267-705e-abd3-36744c666ce6",
        "storage_key": "property/6737460151192629/019e1df4-8267-705e-abd3-36744c666ce6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/campbell-lake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6847212567647828084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-lake-park",
      "poi_latitude": "34.7956794",
      "poi_longitude": "-92.3516307",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa8kpt7Kj0ocRdDg9XI0vBl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ef9a9254-8c02-49ac-93e5-6f4b68716095",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Big Rock Quarry",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bay Oaks Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-84bc-75ed-a425-950c730ec7e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-84bc-75ed-a425-950c730ec7e7",
        "storage_key": "property/6737460151192629/019e1df4-84bc-75ed-a425-950c730ec7e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nlrpr.org/cms/one.aspx?portalId=96195&pageId=200421",
      "poi_directions_map_url": "https://maps.google.com/?cid=8983319870280631652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-rock-quarry",
      "poi_latitude": "34.7800996",
      "poi_longitude": "-92.3045839",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxscPIej0ocRZAXJi9Mpq3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1ea90d4d-915c-4a25-bedc-9544ce689c2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Emerald Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3098 W Scenic Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "Park with a paved trail along a river, popular for walking, hiking, and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-541c-710b-843d-0ddf3f0620b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-541c-710b-843d-0ddf3f0620b9",
        "storage_key": "property/6737460151192629/019e1df2-541c-710b-843d-0ddf3f0620b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/emerald-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14860266810328559427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerald-park",
      "poi_latitude": "34.7842215",
      "poi_longitude": "-92.3007033",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xyQW8u80ocRQy8pUe5FOs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_82c8cf15-c815-4688-9f79-21af8e16be61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "North Shore Riverwalk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Little Rock, AR 72114, USA",
      "poi_short_description": "City park featuring a riverwalk, trails, and a bridge, plus space for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-87e4-7428-8707-055f8441c765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-87e4-7428-8707-055f8441c765",
        "storage_key": "property/6737460151192629/019e1df4-87e4-7428-8707-055f8441c765.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.nps.gov/places/north-shore-riverwalk-park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4170622964056154528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-shore-riverwalk-park",
      "poi_latitude": "34.7533362",
      "poi_longitude": "-92.2714573",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-758-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6890-76bb-a4c9-f702e04af46a",
        "storage_key": "property/6737460151192629/019e1df2-6890-76bb-a4c9-f702e04af46a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw283eYK80ocRoGGnKH0H4Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0b643479-ea7d-4603-9218-f581515cb439",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "River Cities Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Capitol Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-884e-7178-b795-2345be399e7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-884e-7178-b795-2345be399e7e",
        "storage_key": "property/6737460151192629/019e1df4-884e-7178-b795-2345be399e7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809342745980765106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-cities-travel-center",
      "poi_latitude": "34.7442945",
      "poi_longitude": "-92.2680391",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuazOJHq70ocRsgPlcQuB3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_e723f07f-9c57-4665-8192-dd0edf248e36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-5b40-730d-bdb9-cfb1d0b2eec8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-5b40-730d-bdb9-cfb1d0b2eec8",
        "storage_key": "property/6737460151192629/019e1df2-5b40-730d-bdb9-cfb1d0b2eec8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6b7d-70cd-897e-20a79a524fa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6b7d-70cd-897e-20a79a524fa5",
        "storage_key": "property/6737460151192629/019e1df2-6b7d-70cd-897e-20a79a524fa5.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_76d09ea6-f5fc-47de-9fe6-748dfdd50c45",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-5285-70f4-898c-b670ba34ecd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-5285-70f4-898c-b670ba34ecd8",
        "storage_key": "property/6737460151192629/019e1df2-5285-70f4-898c-b670ba34ecd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6b1e-7466-abb3-8afc1530124a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6b1e-7466-abb3-8afc1530124a",
        "storage_key": "property/6737460151192629/019e1df2-6b1e-7466-abb3-8afc1530124a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_5b546e0b-6733-44ed-a306-d1e754b30c39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "North Little Rock Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8200 Remount Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-5bdb-7055-8c7d-d1652aaba154.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-5bdb-7055-8c7d-d1652aaba154",
        "storage_key": "property/6737460151192629/019e1df2-5bdb-7055-8c7d-d1652aaba154.webp",
        "width": 1280,
        "height": 582
      },
      "poi_business_url": "http://nlr.ar.gov/government/a_z_department_list/airport/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14818561348559290970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-municipal-airport",
      "poi_latitude": "34.831655",
      "poi_longitude": "-92.2591882",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-835-5654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-6b1e-7466-abb3-8afc1530124a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-6b1e-7466-abb3-8afc1530124a",
        "storage_key": "property/6737460151192629/019e1df2-6b1e-7466-abb3-8afc1530124a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9wudIW90ocRWsI1zwgbps0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ee4d113b-721c-4667-af43-f82eecf2014d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Robinson Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "426 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_long_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-6e7c-7669-a525-8af1b4450390.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-6e7c-7669-a525-8af1b4450390",
        "storage_key": "property/6737460151192629/019e1df4-6e7c-7669-a525-8af1b4450390.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.robinsoncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15299738811072087964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robinson-center",
      "poi_latitude": "34.7492294",
      "poi_longitude": "-92.2744598",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-244-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0xGEWO70ocRnIc1HmOXU9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_85a33854-5384-4dcd-b18a-15aeddb4ded0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Baptist Health Urgent Care - North Little Rock (JFK)",
      "poi_type": "Transportation & Transit",
      "poi_address": "5505 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.urgentteam.com/locations/baptist-health-urgent-care-north-little-rock-john-f-kennedy-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7727974723384914706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-urgent-care---north-little-rock-jfk",
      "poi_latitude": "34.805759",
      "poi_longitude": "-92.2525199",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-992-9150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2pvk6m90ocREjOO_BBIP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8ef81fe3-e46e-47ab-9705-0d223e8ce1e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Transportation & Transit",
      "poi_address": "4000 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-8bab-776d-b46e-cb03b9ced1bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-8bab-776d-b46e-cb03b9ced1bc",
        "storage_key": "property/6737460151192629/019e1df4-8bab-776d-b46e-cb03b9ced1bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=16241348285058618148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "34.790299",
      "poi_longitude": "-92.229005",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-753-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZfj0Si80ocRJJNRBDfcZOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_16ecb2b7-aac1-413f-952a-28cf97d0552a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Little Rock River Market",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Riverside hub with an international food hall, a twice-weekly farmer's market & frequent concerts.",
      "poi_long_description": "Riverside hub with an international food hall, a twice-weekly farmer's market & frequent concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-8ba3-76c3-9fca-f400992fb15d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-8ba3-76c3-9fca-f400992fb15d",
        "storage_key": "property/6737460151192629/019e1df4-8ba3-76c3-9fca-f400992fb15d.webp",
        "width": 640,
        "height": 428
      },
      "poi_business_url": "http://www.rivermarket.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16636751081372703839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-river-market",
      "poi_latitude": "34.7476319",
      "poi_longitude": "-92.2661051",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-2552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682d-76af-bda0-5fce729df89d",
        "storage_key": "property/6737460151192629/019e1df2-682d-76af-bda0-5fce729df89d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRS8yn670ocRX9zQlfac4eY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "custom_e3c75e2d-b777-4cbe-9410-fb1f270fb69c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Heifer International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-8c6d-709d-96d9-cd3b6ae00ba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-8c6d-709d-96d9-cd3b6ae00ba8",
        "storage_key": "property/6737460151192629/019e1df4-8c6d-709d-96d9-cd3b6ae00ba8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.heifer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15947581606820737385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heifer-international",
      "poi_latitude": "34.7447963",
      "poi_longitude": "-92.2561293",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-948-6437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6hY55Wj0ocRaXEaPfowUd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_4a1ac98e-22d6-4490-9b46-8f37bc10b00e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "UAMS Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-4b77-72ab-9a33-d2ee41f63827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-4b77-72ab-9a33-d2ee41f63827",
        "storage_key": "property/6737460151192629/019e1df2-4b77-72ab-9a33-d2ee41f63827.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://uamshealth.com/location/uams-medical-center/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=980427499144927317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-medical-center",
      "poi_latitude": "34.7493145",
      "poi_longitude": "-92.3205392",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-686-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682a-7489-8dfa-98f095b8f20d",
        "storage_key": "property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz5GH8ql0ocRVdiOrp0tmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d58e3ccc-5b9a-4e4b-b16a-23c7aada3c80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Arkansas Children's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Children's Way, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-4aae-752a-9917-5ef609175246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-4aae-752a-9917-5ef609175246",
        "storage_key": "property/6737460151192629/019e1df2-4aae-752a-9917-5ef609175246.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800723640570466137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-hospital",
      "poi_latitude": "34.7430995",
      "poi_longitude": "-92.2918544",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-441-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682a-7489-8dfa-98f095b8f20d",
        "storage_key": "property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5Fcp1q70ocRWc9Rbm9yR9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6d7a7b42-d27d-45e8-b480-1b1f2a1b6c74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 Baptist Health Dr, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-8d43-738b-b829-37dc130c1351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-8d43-738b-b829-37dc130c1351",
        "storage_key": "property/6737460151192629/019e1df4-8d43-738b-b829-37dc130c1351.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "https://www.baptist-health.org/find-care/location/Baptist-Health-Medical-Center-Little-Rock",
      "poi_directions_map_url": "https://maps.google.com/?cid=11761299314245094965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-little-rock",
      "poi_latitude": "34.7441024",
      "poi_longitude": "-92.3811957",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682a-7489-8dfa-98f095b8f20d",
        "storage_key": "property/6737460151192629/019e1df2-682a-7489-8dfa-98f095b8f20d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_wGQvGm0ocRNc6fimmHOKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_27a9b20b-b6b0-491f-a17f-da5c1121297a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Little Rock Air Force Base Visitors Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 Vandenberg Blvd, Little Rock AFB, AR 72099, USA",
      "poi_short_description": "Friendly military base (for those with active or veteran ties) featuring airshows and an Exchange.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9021-72fa-b5d5-2aef90ad32ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-9021-72fa-b5d5-2aef90ad32ad",
        "storage_key": "property/6737460151192629/019e1df4-9021-72fa-b5d5-2aef90ad32ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.littlerock.af.mil/News/Article-Display/Article/357778/visitor-center-project-under-way",
      "poi_directions_map_url": "https://maps.google.com/?cid=8043192398982542986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-air-force-base-visitors-center",
      "poi_latitude": "34.8903986",
      "poi_longitude": "-92.1246643",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 501-987-3425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSxBgB_r0ocRivZ5Sd8on28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_6de9c944-ae9e-4bd8-9605-6b0a4bba3c29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Simmons Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 W Capitol Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-8e07-778a-8587-e090b05a46a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-8e07-778a-8587-e090b05a46a2",
        "storage_key": "property/6737460151192629/019e1df4-8e07-778a-8587-e090b05a46a2.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.simmonsbank.com/locations/little-rock-downtown-tower?utm_source=gmb&utm_medium=yext&utm_campaign=locallistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4863110573748472749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-bank",
      "poi_latitude": "34.7442184",
      "poi_longitude": "-92.2757271",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-377-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-994b-700d-b8b9-0e3bd6c1a98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df4-994b-700d-b8b9-0e3bd6c1a98e",
        "storage_key": "property/6737460151192629/019e1df4-994b-700d-b8b9-0e3bd6c1a98e.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJKXv8qGW70ocRrUu5C009fUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_f83de543-6229-4622-a28f-64686e085580",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Dillard's Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Cantrell Rd, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-5360-700c-b1cc-95e9612de4f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df2-5360-700c-b1cc-95e9612de4f4",
        "storage_key": "property/6737460151192629/019e1df2-5360-700c-b1cc-95e9612de4f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049574453805387583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards-corporate-office",
      "poi_latitude": "34.75433659999999",
      "poi_longitude": "-92.2878465",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-376-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96xpTae80ocRPw9NLmz5V5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d7dbe2f0-3d51-459e-aef4-358f820ef56a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Stephens Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 Center St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9131-733b-b522-bc0f8d1879b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-9131-733b-b522-bc0f8d1879b6",
        "storage_key": "property/6737460151192629/019e1df4-9131-733b-b522-bc0f8d1879b6.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.stephens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10642390159901556391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stephens-inc",
      "poi_latitude": "34.747862",
      "poi_longitude": "-92.272615",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-377-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaNdrHy70ocRp34L8nZdsZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_e27961b2-1333-4773-98e5-a1bc60c6b378",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "Acxiom Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 Main St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9052-7359-bc08-535a45eb29be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-9052-7359-bc08-535a45eb29be",
        "storage_key": "property/6737460151192629/019e1df4-9052-7359-bc08-535a45eb29be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.acxiom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11192588742970745420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acxiom-corporation",
      "poi_latitude": "34.7459307",
      "poi_longitude": "-92.2705597",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-342-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-685f-771c-a46b-c6b0e16fff7a",
        "storage_key": "property/6737460151192629/019e1df2-685f-771c-a46b-c6b0e16fff7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXH98Hi70ocRTKLOLSkQVJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_925350e3-98cc-4aa8-ba94-d2c7af2a166b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "custom",
      "poi_name": "University of Arkansas at Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df4-9181-72dd-9992-341d27cc1d1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-9181-72dd-9992-341d27cc1d1c",
        "storage_key": "property/6737460151192629/019e1df4-9181-72dd-9992-341d27cc1d1c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ualr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912235513023897276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas-at-little-rock",
      "poi_latitude": "34.7252717",
      "poi_longitude": "-92.3378705",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 501-916-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df2-682f-7189-b03c-b00a68b2e3a3",
        "storage_key": "property/6737460151192629/019e1df2-682f-7189-b03c-b00a68b2e3a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_aUdFik0ocRvB5dKX0wEsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "custom_851566a8-b5ec-40fc-b495-e319484f4415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_88d54494-e596-40c8-b27e-5588dbda7d44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_28ee3196-da9c-42bc-a82f-ffd1a5226f6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aeb27dc5-41e8-4cbe-868f-78bbd79fd041",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2428375b-7af9-4e66-9a21-8be008a5173e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_21bf1b79-8a73-4983-86fa-0b2b900ac652",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c841732f-c4ea-449d-bdbf-a8971643b3f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "rating": "5",
      "name": "Clarence Jones",
      "text": "I've lived here at OverBrook Apartments for almost 4yrs now. The experience has been good and especially whenever I have a maintenance issue with anything. Most of the issues are resolved by Gerado, he really cares about his work and also the residents that live here as well.",
      "date": "2026-05-22",
      "title": "false"
    },
    {
      "id": "custom_611180a5-c2aa-44d4-854c-71d7f6c9b368",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "rating": "5",
      "name": "Kasie Wilkerson",
      "text": "I wanted to take a moment to recognize the work of the maintenance technician, Gerardo! I’ve had a couple of issues and one was being an emergency, I put the order in and within 10 minutes he was knocking at the door, He is consistently prompt, professional, and incredibly reliable.\n\nWhat really stands out is his attention to detail and the pride he takes in his work. He doesn’t just fix the problem; he makes sure everything is working properly before he leaves and takes the time to explain all the details.\nHe’s also respectful of the space, always leaving things clean!\n\nGerardo has a positive attitude and I’ve only lived here a few months, every resident I talk to has nothing but good things to say about him and his work and character. He makes living at overbrook a better experience! Thank you.",
      "date": "2026-05-22",
      "title": "false"
    },
    {
      "id": "custom_cf0e7c78-7391-422a-8072-0acae3070a26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "rating": "5",
      "name": "Ronald Dunlap",
      "text": "I have to share my experience here at Overbrook Apartments in North Little Rock. When I say that the staff here has catered to everyone of my needs, I mean they have catered to everything. They have taken such good care of me. I am paralyzed and they have accommodated me in so many ways, from the Handicap parking and ramp to my mailbox being at my door, to even take my trash out for me. They have also modified my apartment with safety rails in my roll in Handicap accessibleshower and anything else I have asked for I want to give a special shout out to “Simon Rich Johnson” the leasing agent Who has gone above and beyond to make sure that I’m taking care of. I can’t say enough Good things about this place. I plan on being here forever.",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_0fb74c62-bd1b-4894-be39-fceb23c1cfff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "rating": "5",
      "name": "Oliviaaa Smithh",
      "text": "Simon is very nice and made the process easy and fun to move in !",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_3b6b88fc-e9aa-41b1-a81c-ba757b360acd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "rating": "5",
      "name": "Kendel Thornton",
      "text": "We haven’t lived here long, so I can’t really speak on the quality of living here, but the people at the leasing office are amazing. Maggie helped us through the entire process and ensured that we understood everything there is to know about renting and our lease. As first time renters, we can say she was incredible and went above and beyond to help us.",
      "date": "2026-04-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_eefd30cc7dcec5457c6428ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/01a00936-d230-7449-bc63-06d7005bb504.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a00936-d230-7449-bc63-06d7005bb504",
        "storage_key": "property/6737460151192629/01a00936-d230-7449-bc63-06d7005bb504.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "false",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wFBxCBAP6ym"
    },
    {
      "id": "ec_8acf680ef4f85d81d80ac612",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/01a00936-d459-74c9-a9f3-2f430d7ef439.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a00936-d459-74c9-a9f3-2f430d7ef439",
        "storage_key": "property/6737460151192629/01a00936-d459-74c9-a9f3-2f430d7ef439.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "false",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yqL48WfW1ij"
    },
    {
      "id": "ec_0013a7458d65a0a378cab5b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/01a00936-d3cf-76dc-b256-8583cdf07444.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a00936-d3cf-76dc-b256-8583cdf07444",
        "storage_key": "property/6737460151192629/01a00936-d3cf-76dc-b256-8583cdf07444.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "false",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=i6Gk1tF6Mpd"
    },
    {
      "id": "ec_7eb50b73502358b6217258a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/01a00936-d333-7658-b6a1-d74595c84d06.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a00936-d333-7658-b6a1-d74595c84d06",
        "storage_key": "property/6737460151192629/01a00936-d333-7658-b6a1-d74595c84d06.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g1sJ3M6qzFN"
    },
    {
      "id": "ec_d9cd81c73345784009320893",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/01a00936-d40f-77f9-894b-88c7c19b6cd6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a00936-d40f-77f9-894b-88c7c19b6cd6",
        "storage_key": "property/6737460151192629/01a00936-d40f-77f9-894b-88c7c19b6cd6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NrkMuFPCGXb"
    },
    {
      "id": "ec_9c0c94bcbbfe749ad12b27fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/01a00936-d9cb-73f4-a44c-c9b5628dc8c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a00936-d9cb-73f4-a44c-c9b5628dc8c9",
        "storage_key": "property/6737460151192629/01a00936-d9cb-73f4-a44c-c9b5628dc8c9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Juniper II - 955 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6kexapMBxnr"
    },
    {
      "id": "ec_9e8be1cc8e1e48e413d2d618",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=0"
    },
    {
      "id": "ec_3c93255b29c917bbd170a601",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=1"
    },
    {
      "id": "ec_eef7531be45ae018237b5c35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Leasing",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=2"
    },
    {
      "id": "ec_3addb0cabdffd71bd0dc806e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "TV Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=3"
    },
    {
      "id": "ec_accf9b05e6355dd9609888bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Event Kitchen",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=4"
    },
    {
      "id": "ec_94d8109530976b1649537e04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=5"
    },
    {
      "id": "ec_757968c7c0656df5bccc9a87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=6"
    },
    {
      "id": "ec_64610b896dc3133c02d84a48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Swimming Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=7"
    },
    {
      "id": "ec_ed00b22663adb0a0f567d803",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Poolside Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=8"
    },
    {
      "id": "ec_d1e4cebd5ee7d0c74cf247d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "BBQ Area",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=9"
    },
    {
      "id": "ec_4e2a8a5dec17d577b6ae4d68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fire Pit",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=10"
    },
    {
      "id": "ec_9f7454f9a16ee353ea44efac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Playground",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=11"
    },
    {
      "id": "ec_2a963b8614b4fdd97bed4745",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "2 Bed l 2 Bath",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634&c=12"
    },
    {
      "id": "ec_f47a93e44d25e8ddd7b6062a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df2-211d-71e5-89b1-62126904eb05",
        "storage_key": "property/6737460151192629/019e1df2-211d-71e5-89b1-62126904eb05.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "3D Property Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=66838820c5e71e10fda2c634"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e7a-932b-7195-91b5-14933164effc",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-overbrook-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629"
    },
    {
      "lead_collector_id": "01996472-4cb4-7768-a243-24e8e65a9972",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-overbrook-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "apartments-with-pool-north-little-rock-ar-overbrook",
      "search_query": "apartments with pool North Little Rock AR",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in North Little Rock, AR",
      "h2_subtitle": "Discover apartments with a pool in North Little Rock, AR. Experience the best of community living at Overbrook with our premium amenities.",
      "page_copy": "Welcome to Overbrook, the leading choice for those seeking apartments with pool North Little Rock AR. Nestled in the charming neighborhood of North Little Rock, Overbrook offers residents a refreshing escape with our sparkling swimming pool. Whether you prefer lounging poolside or taking a dip, our pool area is designed to deliver both relaxation and recreation.\n\nAt Overbrook, you can select from spacious one to three-bedroom floor plans perfect for any lifestyle. Beyond our pool, amenities such as a fully-equipped fitness center, engaging planned social activities, and a dedicated property manager on site enhance your living experience. Come tour our vibrant community and see why Overbrook is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool - North Little Rock, AR",
      "seo_description": "Explore Overbrook's apartments with a pool in North Little Rock, AR. Enjoy amenities like a fitness center and social activities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-pulaski-county-overbrook",
      "search_query": "fitness center apartments near Pulaski County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Pulaski County",
      "h2_subtitle": "Find apartments with a fitness center near Pulaski County. Overbrook offers convenient access and premium on-site amenities.",
      "page_copy": "Welcome to Overbrook, where we offer fitness center apartments near Pulaski County. Our state-of-the-art fitness center is perfect for those looking to stay healthy without leaving home. Whether you're into cardio, weight training, or finding your zen in a quiet corner, our fitness center has something for everyone.\n\nNestled in North Little Rock, Overbrook provides a diverse range of floor plans, including one, two, and three-bedroom options. Beyond our fitness offerings, enjoy our welcoming community with a sparkling pool and planned social activities. Experience the convenience and vibrant lifestyle that comes with living at Overbrook. Schedule a tour today and see why our residents love calling Overbrook home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Fitness Center Near Pulaski County",
      "seo_description": "Discover Overbrook's fitness center apartments near Pulaski County. Enjoy premium amenities like a pool and social activities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "pet-friendly-gated-apartments-72116-overbrook",
      "search_query": "pet-friendly apartments with gated access 72116",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Gated Access 72116",
      "h2_subtitle": "Explore pet-friendly apartments with gated access in the 72116 area. Overbrook is the perfect place for you and your furry friends.",
      "page_copy": "Discover Overbrook, a community offering pet-friendly apartments with gated access in the heart of the 72116 area. We welcome your furry companions with open arms and provide a safe environment with our gated access, ensuring peace of mind for you and your pets.\n\nOur spacious one, two, and three-bedroom apartments are perfect for pet owners seeking comfort and convenience. Beyond the gated community, residents enjoy a wealth of amenities like a sparkling pool, fitness center, and a vibrant social calendar, making Overbrook the perfect place to call home. Visit us today to tour our welcoming community and see why pet owners love living here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Gated Apartments in 72116",
      "seo_description": "Find pet-friendly, gated apartments in the 72116 area at Overbrook. Enjoy a secure community with premium amenities. Tour our pet-friendly community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "luxurious-clubhouse-apartments-north-little-rock",
      "search_query": "North Little Rock luxurious clubhouse apartments",
      "category": "Amenity",
      "h1_title": "North Little Rock Luxurious Clubhouse Apartments",
      "h2_subtitle": "Experience luxurious clubhouse apartments in North Little Rock at Overbrook. Enjoy premium amenities and vibrant community living.",
      "page_copy": "Welcome to Overbrook, the top choice for those seeking North Little Rock luxurious clubhouse apartments. Our upscale clubhouse offers a sophisticated setting for relaxation, entertaining, or socializing with fellow residents. With elegant décor and ample space, it’s the hub of community life where you can unwind or engage in planned social activities.\n\nLocated in the heart of North Little Rock, Overbrook features a variety of floor plans from one to three bedrooms, catering to every lifestyle. Alongside our luxurious clubhouse, enjoy amenities such as a pristine pool and cutting-edge fitness center. Join us at Overbrook and experience luxury living in a welcoming environment. Schedule a visit today to see all that we offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxurious Clubhouse Apartments in North Little Rock",
      "seo_description": "Explore Overbrook's luxurious clubhouse apartments in North Little Rock. Discover premium amenities and vibrant community life. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "apartments-playground-picnic-area-ar-overbrook",
      "search_query": "apartments with playground and picnic area AR",
      "category": "Amenity",
      "h1_title": "Apartments with Playground and Picnic Area AR",
      "h2_subtitle": "Discover Overbrook's apartments with a playground and picnic area. Enjoy family-friendly amenities in AR's welcoming community.",
      "page_copy": "Overbrook proudly offers apartments with playground and picnic area in AR, perfect for families and outdoor lovers. The on-site playground provides endless fun for children, while the picnic area invites residents to enjoy meals al fresco with friends and family.\n\nLocated in North Little Rock, AR, Overbrook features spacious one, two, and three-bedroom options, designed with comfort and convenience in mind. Beyond the playground and picnic area, residents can take advantage of our sparkling pool, fitness center, and vibrant social calendar. Experience a lifestyle that blends relaxation and recreation at Overbrook. Visit us today and discover why families love living in our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Playground & Picnic Area in AR",
      "seo_description": "Find Overbrook's apartments with playground and picnic area in AR. Enjoy family-friendly amenities. Tour our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-north-little-rock-ar-overbrook",
      "search_query": "1 bedroom apartments North Little Rock AR",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments North Little Rock AR",
      "h2_subtitle": "Explore our 1 bedroom apartments in North Little Rock, AR. Overbrook offers spacious layouts and top-notch amenities.",
      "page_copy": "Discover the ideal living space with Overbrook's 1 bedroom apartments North Little Rock AR. Spacious and stylish, these apartments provide the perfect combination of comfort and convenience. Our thoughtfully designed floor plans are tailored to meet your needs, featuring modern amenities in a welcoming environment.\n\nOverbrook's location in North Little Rock, AR, offers easy access to local attractions, while our community amenities, such as a fitness center and pool, add an extra layer of relaxation to everyday life. With a vibrant community atmosphere and a commitment to resident satisfaction, Overbrook is the perfect place to call home. Visit us to explore our available units and find your perfect match today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in North Little Rock, AR",
      "seo_description": "Explore Overbrook's 1 bedroom apartments in North Little Rock, AR. Enjoy spacious layouts and modern amenities. Visit us to find your perfect home!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-pulaski-county-overbrook",
      "search_query": "2 bedroom apartments Pulaski County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Pulaski County",
      "h2_subtitle": "Discover Overbrook's spacious 2 bedroom apartments in Pulaski County. Enjoy comfort and convenience in a vibrant community.",
      "page_copy": "Searching for the perfect 2 bedroom apartments in Pulaski County? Overbrook offers spacious and well-designed layouts, perfect for individuals or small families. Each unit provides ample space and modern finishes, ensuring a comfortable living environment.\n\nNestled in North Little Rock, Overbrook combines the tranquility of suburban living with the convenience of city access. Enjoy community amenities like our serene pool, fitness center, and a welcoming clubhouse where neighbors gather. Come tour our community today to see why Overbrook is the ideal place for your next home in Pulaski County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Explore 2 Bedroom Apts in Pulaski County",
      "seo_description": "Discover spacious 2 bedroom apartments at Overbrook in Pulaski County. Enjoy modern amenities and vibrant community living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192629",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-72116-overbrook",
      "search_query": "3 bedroom apartments near 72116",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 72116",
      "h2_subtitle": "Find spacious 3 bedroom apartments near 72116 at Overbrook. Enjoy a vibrant community with top amenities.",
      "page_copy": "If you're looking for spacious 3 bedroom apartments near 72116, Overbrook is your ideal destination. Our community offers comfortable and expansive living spaces, designed to accommodate both families and those who enjoy a bit more room.\n\nLocated in North Little Rock, AR, Overbrook provides a unique blend of comfort and convenience. Our residents have access to fantastic amenities, including a refreshing pool, fitness center, and a variety of planned social activities. Discover the perfect 3 bedroom apartment that meets all your needs in a community that's ready to welcome you with open arms. Schedule a tour today and see what makes Overbrook a standout choice near 72116.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "019d0784-42ed-70cc-8fc0-5a5b32a2f41b",
        "storage_key": "property/6737460151192629/019d0784-42ed-70cc-8fc0-5a5b32a2f41b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apts Near 72116 | Overbrook",
      "seo_description": "Explore spacious 3 bedroom apartments near 72116 at Overbrook. Enjoy modern comforts and community amenities. Visit us to find your ideal home!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3373"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483083"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4707264"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_l_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=l"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TJ3989JT"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_l_title",
      "type": "STRING",
      "value": "Locator"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-510-8494"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-509-9282"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_l_number",
      "type": "STRING",
      "value": "501-509-9748"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "501-509-9436"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-509-9498"
    },
    {
      "ID": "custom_knock_a247_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=a247"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-506-5126"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-510-5926"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-509-9411"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-510-6670"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-509-9474"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-203-9765"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_a247_title",
      "type": "STRING",
      "value": "Apartments247"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-290-4431"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-509-9651"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "501-434-4637"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "501-439-4899"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-300-8544"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "501-382-8307"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_a247_number",
      "type": "STRING",
      "value": "501-430-4945"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-381-5594"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-600-2583"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321210659"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-509-9634"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-419-1085"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "311eefe84f294115"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "501-457-9266"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-510-6689"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-799-7141"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-361-1595"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-510-6671"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-273-3833"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-509-9430"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.overbrookapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192629/019e6473-9b55-725f-87e5-c9ae82c882b8.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-509-9247"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-203-9765"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3373",
  "custom_repli_id": "5028483083",
  "custom_realpage_id": "4707264",
  "custom_knock_a_link": "https://www.overbrookapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.overbrookapthome.com?utm_knock=g",
  "custom_knock_l_link": "https://www.overbrookapthome.com?utm_knock=l",
  "custom_knock_r_link": "https://www.overbrookapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.overbrookapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-TJ3989JT",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.overbrookapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.overbrookapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.overbrookapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.overbrookapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.overbrookapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.overbrookapthome.com?utm_knock=gp",
  "custom_knock_l_title": "Locator",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-510-8494",
  "custom_knock_ads_link": "https://www.overbrookapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.overbrookapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "501-509-9282",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_l_number": "501-509-9748",
  "custom_knock_lcs_link": "https://www.overbrookapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.overbrookapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.overbrookapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.overbrookapthome.com?utm_knock=psa",
  "custom_knock_r_number": "501-509-9436",
  "custom_knock_w_number": "501-509-9498",
  "custom_knock_a247_link": "https://www.overbrookapthome.com?utm_knock=a247",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-506-5126",
  "custom_knock_amap_link": "https://www.overbrookapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "501-510-5926",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-509-9411",
  "custom_knock_fb_number": "501-510-6670",
  "custom_knock_fl_number": "501-509-9474",
  "custom_knock_gp_number": "501-203-9765",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.overbrookapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_a247_title": "Apartments247",
  "custom_knock_ads_number": "501-290-4431",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.overbrookapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-509-9651",
  "custom_knock_cfres_link": "https://www.overbrookapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "501-434-4637",
  "custom_knock_lgp_number": "501-439-4899",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.overbrookapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "501-300-8544",
  "custom_knock_psa_number": "501-382-8307",
  "custom_seo_subscription": "essential",
  "custom_knock_a247_number": "501-430-4945",
  "custom_knock_amap_number": "501-381-5594",
  "custom_knock_bandit_link": "https://www.overbrookapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.overbrookapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-600-2583",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321210659",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-509-9634",
  "custom_knock_cfres_number": "501-419-1085",
  "custom_knock_chatgpt_link": "https://www.overbrookapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "311eefe84f294115",
  "custom_knock_dirmail_link": "https://www.overbrookapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "501-457-9266",
  "custom_knock_propbro_link": "https://www.overbrookapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "501-510-6689",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-799-7141",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.overbrookapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-361-1595",
  "custom_knock_dirmail_number": "501-510-6671",
  "custom_knock_propbro_number": "501-273-3833",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "501-509-9430",
  "custom_knock_maintenance_link": "https://www.overbrookapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192629/019e6473-9b55-725f-87e5-c9ae82c882b8.mp4",
  "custom_knock_maintenance_number": "501-509-9247",
  "custom_ppc_tracking_phone_number": "501-203-9765",
  "custom_audioeye_site_id": "2cb80521-22d2-45f9-b789-3a47150c7efc",
  "custom_audioeye_site_hash": "588a07f140eeff8bfdf2ee3286269bd0"
};

export const generatedAt = '2026-11-03T21:52:56.365Z';
